import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_POPOVER } from '../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../util/feature-cache'
import {
  LineItemFulfilmentDetailsViewProps,
  LineItemFulfilmentDetailsView as LineItemFulfilmentDetailsViewUnified,
} from './LineItemFulfilmentDetailsView'
import { LineItemFulfilmentDetailsViewLegacy } from './LineItemFulfilmentDetailsViewLegacy'

export const LineItemFulfilmentDetailsView: React.FC<LineItemFulfilmentDetailsViewProps> = props => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_POPOVER
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <LineItemFulfilmentDetailsViewUnified {...props} />
  ) : (
    <LineItemFulfilmentDetailsViewLegacy {...props} />
  )
}

export type { LineItemFulfilmentDetailsViewProps }
